// CriOS is used by Chrome on iOS
const CHROMIUM_UA_STRINGS = ['Chrome', 'CriOS'];
const SAFARI_USER_AGENT = 'safari';
const NAVIGATOR_DO_NOT_TRACK_IS_ENABLED = '1';

export const isChromiumAgent = () =>
  CHROMIUM_UA_STRINGS.some((chromeUaString) =>
    window.navigator?.userAgent.includes(chromeUaString)
  );

export const isSafariAgent = () => {
  const isSafari = window.navigator?.userAgent.includes(SAFARI_USER_AGENT);

  return isSafari && !isChromiumAgent();
};

/**
 *  This util prevents possible error messages envolving the Firefox browser
 * with ServiceWorkers. By default, Firefox works perfectly with
 * ServiceWorkers, but when this browser is configured with Strict Privacity
 * mode, he don't allows to access and use the ServiceWorkers API.
 *
 *  To know if the browser of user has this option enabled, we can verify if
 * the 'navigator.dotNoTrack' is equals to '1', if is different of this
 * (e.g: 'unspecified' or null), this option is disabled.
 *
 * more info: https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API#service_worker_concepts_and_usage
 */
export const isServiceWorkersSupported = () =>
  navigator?.userAgent.includes('Firefox')
    ? navigator?.doNotTrack !== NAVIGATOR_DO_NOT_TRACK_IS_ENABLED
    : true;
